import { render, staticRenderFns } from "./ShipmentForm.vue?vue&type=template&id=2362ee72"
import script from "./ShipmentForm.vue?vue&type=script&lang=js"
export * from "./ShipmentForm.vue?vue&type=script&lang=js"
import style0 from "./ShipmentForm.vue?vue&type=style&index=0&id=2362ee72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports